import { useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Search, GraduationCap, ChevronDown } from "lucide-react";
import { PageHeader, GlassCard, Chip } from "../components/ui";
import { LEARNING } from "../constants";

export default function Learning() {
  const [query, setQuery] = useState("");
  const [cat, setCat] = useState("All");
  const [open, setOpen] = useState(null);

  const cats = useMemo(() => ["All", ...Array.from(new Set(LEARNING.map((l) => l.cat)))], []);
  const filtered = LEARNING.filter((l) =>
    (cat === "All" || l.cat === cat) &&
    (l.title.toLowerCase().includes(query.toLowerCase()) || l.body.toLowerCase().includes(query.toLowerCase()) || l.cat.toLowerCase().includes(query.toLowerCase()))
  );

  return (
    <div className="space-y-6">
      <PageHeader label="Education" title="Learning Center"
        subtitle="Plain-English education on business credit, personal credit, funding, and more." />

      <GlassCard className="p-4">
        <div className="relative">
          <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" />
          <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search topics…"
            className="cc-input w-full rounded-xl pl-11 pr-4 py-3 text-sm" data-testid="learning-search" />
        </div>
        <div className="mt-4 flex flex-wrap gap-2">
          {cats.map((c) => (
            <button key={c} onClick={() => setCat(c)}
              className={`rounded-full px-3.5 py-1.5 text-xs ${cat === c ? "cc-gradient text-white" : "border border-white/10 text-slate-400 cc-nav-item"}`}>
              {c}
            </button>
          ))}
        </div>
      </GlassCard>

      <div className="grid md:grid-cols-2 gap-4">
        {filtered.map((l, i) => {
          const isOpen = open === i;
          return (
            <GlassCard key={l.title} className="p-5" data-testid="learning-card">
              <button onClick={() => setOpen(isOpen ? null : i)} className="w-full text-left">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <Chip tone="purple">{l.cat}</Chip>
                    <h3 className="cc-heading text-base font-500 text-white mt-2.5">{l.title}</h3>
                  </div>
                  <ChevronDown size={18} className={`text-slate-500 shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`} />
                </div>
              </button>
              <AnimatePresence>
                {isOpen && (
                  <motion.p initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
                    className="text-sm text-slate-400 leading-relaxed mt-3 overflow-hidden">
                    {l.body}
                  </motion.p>
                )}
              </AnimatePresence>
            </GlassCard>
          );
        })}
      </div>
      {filtered.length === 0 && (
        <GlassCard className="p-12 text-center text-slate-500">
          <GraduationCap className="mx-auto mb-3 text-slate-600" size={28} />
          No topics match your search.
        </GlassCard>
      )}
    </div>
  );
}
